import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  additionalInfoHeader: {
    display: 'flex',
    justifyContent: 'center',
    margin: '5rem auto',
    textAlign: 'start',
  },
  fileUpload: {
    marginBottom: '8rem',
    textAlign: 'left',
  },
  subtitle: {
    paddingBottom: '2rem',
    borderBottom: `0.1rem solid ${colors.neutral[300]}`,
  },
  sponsorField: {
    marginRight: '4rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
